import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import GamePresenter from "../components/GamePresenter.vue";
import HomePresenter from "../components/HomePresenter.vue";
const routes: Array<RouteRecordRaw> = [
  { path: "/", name: "home", component: HomePresenter },
  { path: "/game/:id", name: "game", component: GamePresenter },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
